<template>
  <div :class="$style.container">
    <div :class="$style.text">
      Made with
      <IconHeart :class="$style.heartIcon" />
      by
    </div>
    <a
      href="https://www.netguru.co/"
      target="_blank"
      rel="noopener"
      title="Netguru"
    >
      <NetguruLogo :class="$style.netguruLogo" />
    </a>
  </div>
</template>

<script>
import NetguruLogo from '@/assets/netguru.svg';
import IconHeart from '@/assets/heart.svg';

export default {
  components: {
    NetguruLogo,
    IconHeart,
  },
};
</script>

<style module lang="scss">
  .container {
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .text {
    display: flex;
    margin-bottom: 20px;
    font-size: $fs-small;
    align-items: center;
  }

  .heartIcon {
    height: 16px;
    margin: 0 10px;
    color: $c-red;
  }

  .netguruLogo {
    color: $c-white;
  }
</style>
